var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallCalling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.06 6.449 4.127 3.334M15.689 14.228l4.126 3.334",
    stroke: "#00C0C0",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.106 5.578.674.545a2.49 2.49 0 0 1 .307 3.582l-.093.107c-.67.764-.85 1.892-.18 2.655.64.73 1.5 1.372 2.747 2.072.985.552 2.215.29 2.959-.557l.065-.075a2.51 2.51 0 0 1 3.462-.297l.626.506c.898.726 1.211 1.993.565 2.95-.61.904-1.289 1.61-2.091 2.188-.512.369-1.172.45-1.78.287-5.958-1.6-9.562-4.506-12.147-9.89-.225-.468-.299-1.007-.116-1.494.385-1.029 1.106-1.895 2.22-2.724.832-.619 1.976-.506 2.782.145Z",
    stroke: "#1E208D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m17.784 6.242-2.216 2.2M19 9.415 17.315 10M14 6.674 14.6 5",
    stroke: "#00C0C0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCalling);
export default __webpack_public_path__ + "static/media/call_calling.ed1f61a5079ae307a070ccfc4f73a558.svg";
export { ForwardRef as ReactComponent };